export const locations = [
    {
        provinceId: '11',
        provinceName: '北京',
        cities: [
            {
                cityCode: '110116',
                cityName: '怀柔区',
                provinceId: '11',
            },
            {
                cityCode: '110117',
                cityName: '平谷区',
                provinceId: '11',
            },
            {
                cityCode: '110114',
                cityName: '昌平区',
                provinceId: '11',
            },
            {
                cityCode: '110115',
                cityName: '大兴区',
                provinceId: '11',
            },
            {
                cityCode: '110112',
                cityName: '通州区',
                provinceId: '11',
            },
            {
                cityCode: '110113',
                cityName: '顺义区',
                provinceId: '11',
            },
            {
                cityCode: '110111',
                cityName: '房山区',
                provinceId: '11',
            },
            {
                cityCode: '110118',
                cityName: '密云区',
                provinceId: '11',
            },
            {
                cityCode: '110119',
                cityName: '延庆区',
                provinceId: '11',
            },
            {
                cityCode: '110105',
                cityName: '朝阳区',
                provinceId: '11',
            },
            {
                cityCode: '110106',
                cityName: '丰台区',
                provinceId: '11',
            },
            {
                cityCode: '110101',
                cityName: '东城区',
                provinceId: '11',
            },
            {
                cityCode: '110102',
                cityName: '西城区',
                provinceId: '11',
            },
            {
                cityCode: '110109',
                cityName: '门头沟区',
                provinceId: '11',
            },
            {
                cityCode: '110107',
                cityName: '石景山区',
                provinceId: '11',
            },
            {
                cityCode: '110108',
                cityName: '海淀区',
                provinceId: '11',
            },
        ],
    },
    {
        provinceId: '12',
        provinceName: '天津',
        cities: [
            {
                cityCode: '120102',
                cityName: '河东区',
                provinceId: '12',
            },
            {
                cityCode: '120103',
                cityName: '河西区',
                provinceId: '12',
            },
            {
                cityCode: '120104',
                cityName: '南开区',
                provinceId: '12',
            },
            {
                cityCode: '120105',
                cityName: '河北区',
                provinceId: '12',
            },
            {
                cityCode: '120101',
                cityName: '和平区',
                provinceId: '12',
            },
            {
                cityCode: '120106',
                cityName: '红桥区',
                provinceId: '12',
            },
            {
                cityCode: '120113',
                cityName: '北辰区',
                provinceId: '12',
            },
            {
                cityCode: '120114',
                cityName: '武清区',
                provinceId: '12',
            },
            {
                cityCode: '120115',
                cityName: '宝坻区',
                provinceId: '12',
            },
            {
                cityCode: '120116',
                cityName: '滨海新区',
                provinceId: '12',
            },
            {
                cityCode: '120110',
                cityName: '东丽区',
                provinceId: '12',
            },
            {
                cityCode: '120111',
                cityName: '西青区',
                provinceId: '12',
            },
            {
                cityCode: '120112',
                cityName: '津南区',
                provinceId: '12',
            },
            {
                cityCode: '120117',
                cityName: '宁河区',
                provinceId: '12',
            },
            {
                cityCode: '120118',
                cityName: '静海区',
                provinceId: '12',
            },
            {
                cityCode: '120119',
                cityName: '蓟州区',
                provinceId: '12',
            },
        ],
    },
    {
        provinceId: '13',
        provinceName: '河北',
        cities: [
            {
                cityCode: '130900',
                cityName: '沧州市',
                provinceId: '13',
            },
            {
                cityCode: '130600',
                cityName: '保定市',
                provinceId: '13',
            },
            {
                cityCode: '130500',
                cityName: '邢台市',
                provinceId: '13',
            },
            {
                cityCode: '130800',
                cityName: '承德市',
                provinceId: '13',
            },
            {
                cityCode: '130700',
                cityName: '张家口市',
                provinceId: '13',
            },
            {
                cityCode: '130200',
                cityName: '唐山市',
                provinceId: '13',
            },
            {
                cityCode: '130100',
                cityName: '石家庄市',
                provinceId: '13',
            },
            {
                cityCode: '130400',
                cityName: '邯郸市',
                provinceId: '13',
            },
            {
                cityCode: '130300',
                cityName: '秦皇岛市',
                provinceId: '13',
            },
            {
                cityCode: '139001',
                cityName: '定州市',
                provinceId: '13',
            },
            {
                cityCode: '139002',
                cityName: '辛集市',
                provinceId: '13',
            },
            {
                cityCode: '131000',
                cityName: '廊坊市',
                provinceId: '13',
            },
            {
                cityCode: '131100',
                cityName: '衡水市',
                provinceId: '13',
            },
        ],
    },
    {
        provinceId: '14',
        provinceName: '山西',
        cities: [
            {
                cityCode: '140800',
                cityName: '运城市',
                provinceId: '14',
            },
            {
                cityCode: '140700',
                cityName: '晋中市',
                provinceId: '14',
            },
            {
                cityCode: '140900',
                cityName: '忻州市',
                provinceId: '14',
            },
            {
                cityCode: '140400',
                cityName: '长治市',
                provinceId: '14',
            },
            {
                cityCode: '140300',
                cityName: '阳泉市',
                provinceId: '14',
            },
            {
                cityCode: '140600',
                cityName: '朔州市',
                provinceId: '14',
            },
            {
                cityCode: '140500',
                cityName: '晋城市',
                provinceId: '14',
            },
            {
                cityCode: '141100',
                cityName: '吕梁市',
                provinceId: '14',
            },
            {
                cityCode: '140200',
                cityName: '大同市',
                provinceId: '14',
            },
            {
                cityCode: '140100',
                cityName: '太原市',
                provinceId: '14',
            },
            {
                cityCode: '141000',
                cityName: '临汾市',
                provinceId: '14',
            },
        ],
    },
    {
        provinceId: '15',
        provinceName: '内蒙古',
        cities: [
            {
                cityCode: '150600',
                cityName: '鄂尔多斯市',
                provinceId: '15',
            },
            {
                cityCode: '152900',
                cityName: '阿拉善盟',
                provinceId: '15',
            },
            {
                cityCode: '150500',
                cityName: '通辽市',
                provinceId: '15',
            },
            {
                cityCode: '150800',
                cityName: '巴彦淖尔市',
                provinceId: '15',
            },
            {
                cityCode: '150700',
                cityName: '呼伦贝尔市',
                provinceId: '15',
            },
            {
                cityCode: '150200',
                cityName: '包头市',
                provinceId: '15',
            },
            {
                cityCode: '152500',
                cityName: '锡林郭勒盟',
                provinceId: '15',
            },
            {
                cityCode: '150100',
                cityName: '呼和浩特市',
                provinceId: '15',
            },
            {
                cityCode: '150400',
                cityName: '赤峰市',
                provinceId: '15',
            },
            {
                cityCode: '150300',
                cityName: '乌海市',
                provinceId: '15',
            },
            {
                cityCode: '152200',
                cityName: '兴安盟',
                provinceId: '15',
            },
            {
                cityCode: '150900',
                cityName: '乌兰察布市',
                provinceId: '15',
            },
        ],
    },
    {
        provinceId: '21',
        provinceName: '辽宁',
        cities: [
            {
                cityCode: '210900',
                cityName: '阜新市',
                provinceId: '21',
            },
            {
                cityCode: '210800',
                cityName: '营口市',
                provinceId: '21',
            },
            {
                cityCode: '210700',
                cityName: '锦州市',
                provinceId: '21',
            },
            {
                cityCode: '210600',
                cityName: '丹东市',
                provinceId: '21',
            },
            {
                cityCode: '210500',
                cityName: '本溪市',
                provinceId: '21',
            },
            {
                cityCode: '210400',
                cityName: '抚顺市',
                provinceId: '21',
            },
            {
                cityCode: '210300',
                cityName: '鞍山市',
                provinceId: '21',
            },
            {
                cityCode: '211400',
                cityName: '葫芦岛市',
                provinceId: '21',
            },
            {
                cityCode: '210200',
                cityName: '大连市',
                provinceId: '21',
            },
            {
                cityCode: '211300',
                cityName: '朝阳市',
                provinceId: '21',
            },
            {
                cityCode: '210100',
                cityName: '沈阳市',
                provinceId: '21',
            },
            {
                cityCode: '211200',
                cityName: '铁岭市',
                provinceId: '21',
            },
            {
                cityCode: '211100',
                cityName: '盘锦市',
                provinceId: '21',
            },
            {
                cityCode: '211000',
                cityName: '辽阳市',
                provinceId: '21',
            },
        ],
    },
    {
        provinceId: '22',
        provinceName: '吉林',
        cities: [
            {
                cityCode: '220800',
                cityName: '白城市',
                provinceId: '22',
            },
            {
                cityCode: '220700',
                cityName: '松原市',
                provinceId: '22',
            },
            {
                cityCode: '220600',
                cityName: '白山市',
                provinceId: '22',
            },
            {
                cityCode: '220500',
                cityName: '通化市',
                provinceId: '22',
            },
            {
                cityCode: '220400',
                cityName: '辽源市',
                provinceId: '22',
            },
            {
                cityCode: '220300',
                cityName: '四平市',
                provinceId: '22',
            },
            {
                cityCode: '220200',
                cityName: '吉林市',
                provinceId: '22',
            },
            {
                cityCode: '220100',
                cityName: '长春市',
                provinceId: '22',
            },
            {
                cityCode: '222400',
                cityName: '延边朝鲜族自治州',
                provinceId: '22',
            },
        ],
    },
    {
        provinceId: '23',
        provinceName: '黑龙江',
        cities: [
            {
                cityCode: '230700',
                cityName: '伊春市',
                provinceId: '23',
            },
            {
                cityCode: '230600',
                cityName: '大庆市',
                provinceId: '23',
            },
            {
                cityCode: '230500',
                cityName: '双鸭山市',
                provinceId: '23',
            },
            {
                cityCode: '230400',
                cityName: '鹤岗市',
                provinceId: '23',
            },
            {
                cityCode: '232700',
                cityName: '大兴安岭地区',
                provinceId: '23',
            },
            {
                cityCode: '230300',
                cityName: '鸡西市',
                provinceId: '23',
            },
            {
                cityCode: '230200',
                cityName: '齐齐哈尔市',
                provinceId: '23',
            },
            {
                cityCode: '231200',
                cityName: '绥化市',
                provinceId: '23',
            },
            {
                cityCode: '230100',
                cityName: '哈尔滨市',
                provinceId: '23',
            },
            {
                cityCode: '231100',
                cityName: '黑河市',
                provinceId: '23',
            },
            {
                cityCode: '231000',
                cityName: '牡丹江市',
                provinceId: '23',
            },
            {
                cityCode: '230900',
                cityName: '七台河市',
                provinceId: '23',
            },
            {
                cityCode: '230800',
                cityName: '佳木斯市',
                provinceId: '23',
            },
        ],
    },
    {
        provinceId: '31',
        provinceName: '上海',
        cities: [
            {
                cityCode: '310151',
                cityName: '崇明区',
                provinceId: '31',
            },
            {
                cityCode: '310120',
                cityName: '奉贤区',
                provinceId: '31',
            },
            {
                cityCode: '310112',
                cityName: '闵行区',
                provinceId: '31',
            },
            {
                cityCode: '310113',
                cityName: '宝山区',
                provinceId: '31',
            },
            {
                cityCode: '310114',
                cityName: '嘉定区',
                provinceId: '31',
            },
            {
                cityCode: '310115',
                cityName: '浦东新区',
                provinceId: '31',
            },
            {
                cityCode: '310116',
                cityName: '金山区',
                provinceId: '31',
            },
            {
                cityCode: '310117',
                cityName: '松江区',
                provinceId: '31',
            },
            {
                cityCode: '310118',
                cityName: '青浦区',
                provinceId: '31',
            },
            {
                cityCode: '310110',
                cityName: '杨浦区',
                provinceId: '31',
            },
            {
                cityCode: '310101',
                cityName: '黄浦区',
                provinceId: '31',
            },
            {
                cityCode: '310104',
                cityName: '徐汇区',
                provinceId: '31',
            },
            {
                cityCode: '310105',
                cityName: '长宁区',
                provinceId: '31',
            },
            {
                cityCode: '310106',
                cityName: '静安区',
                provinceId: '31',
            },
            {
                cityCode: '310107',
                cityName: '普陀区',
                provinceId: '31',
            },
            {
                cityCode: '310109',
                cityName: '虹口区',
                provinceId: '31',
            },
        ],
    },
    {
        provinceId: '32',
        provinceName: '江苏',
        cities: [
            {
                cityCode: '320400',
                cityName: '常州市',
                provinceId: '32',
            },
            {
                cityCode: '320500',
                cityName: '苏州市',
                provinceId: '32',
            },
            {
                cityCode: '320600',
                cityName: '南通市',
                provinceId: '32',
            },
            {
                cityCode: '320700',
                cityName: '连云港市',
                provinceId: '32',
            },
            {
                cityCode: '320800',
                cityName: '淮安市',
                provinceId: '32',
            },
            {
                cityCode: '320900',
                cityName: '盐城市',
                provinceId: '32',
            },
            {
                cityCode: '321000',
                cityName: '扬州市',
                provinceId: '32',
            },
            {
                cityCode: '321200',
                cityName: '泰州市',
                provinceId: '32',
            },
            {
                cityCode: '321100',
                cityName: '镇江市',
                provinceId: '32',
            },
            {
                cityCode: '321300',
                cityName: '宿迁市',
                provinceId: '32',
            },
            {
                cityCode: '320100',
                cityName: '南京市',
                provinceId: '32',
            },
            {
                cityCode: '320200',
                cityName: '无锡市',
                provinceId: '32',
            },
            {
                cityCode: '320300',
                cityName: '徐州市',
                provinceId: '32',
            },
        ],
    },
    {
        provinceId: '33',
        provinceName: '浙江',
        cities: [
            {
                cityCode: '330200',
                cityName: '宁波市',
                provinceId: '33',
            },
            {
                cityCode: '330300',
                cityName: '温州市',
                provinceId: '33',
            },
            {
                cityCode: '330400',
                cityName: '嘉兴市',
                provinceId: '33',
            },
            {
                cityCode: '330500',
                cityName: '湖州市',
                provinceId: '33',
            },
            {
                cityCode: '330600',
                cityName: '绍兴市',
                provinceId: '33',
            },
            {
                cityCode: '330700',
                cityName: '金华市',
                provinceId: '33',
            },
            {
                cityCode: '330800',
                cityName: '衢州市',
                provinceId: '33',
            },
            {
                cityCode: '330900',
                cityName: '舟山市',
                provinceId: '33',
            },
            {
                cityCode: '331000',
                cityName: '台州市',
                provinceId: '33',
            },
            {
                cityCode: '331100',
                cityName: '丽水市',
                provinceId: '33',
            },
            {
                cityCode: '330100',
                cityName: '杭州市',
                provinceId: '33',
            },
        ],
    },
    {
        provinceId: '34',
        provinceName: '安徽',
        cities: [
            {
                cityCode: '341200',
                cityName: '阜阳市',
                provinceId: '34',
            },
            {
                cityCode: '340100',
                cityName: '合肥市',
                provinceId: '34',
            },
            {
                cityCode: '341300',
                cityName: '宿州市',
                provinceId: '34',
            },
            {
                cityCode: '340200',
                cityName: '芜湖市',
                provinceId: '34',
            },
            {
                cityCode: '340300',
                cityName: '蚌埠市',
                provinceId: '34',
            },
            {
                cityCode: '341500',
                cityName: '六安市',
                provinceId: '34',
            },
            {
                cityCode: '340400',
                cityName: '淮南市',
                provinceId: '34',
            },
            {
                cityCode: '341600',
                cityName: '亳州市',
                provinceId: '34',
            },
            {
                cityCode: '340500',
                cityName: '马鞍山市',
                provinceId: '34',
            },
            {
                cityCode: '341700',
                cityName: '池州市',
                provinceId: '34',
            },
            {
                cityCode: '340600',
                cityName: '淮北市',
                provinceId: '34',
            },
            {
                cityCode: '341800',
                cityName: '宣城市',
                provinceId: '34',
            },
            {
                cityCode: '340700',
                cityName: '铜陵市',
                provinceId: '34',
            },
            {
                cityCode: '340800',
                cityName: '安庆市',
                provinceId: '34',
            },
            {
                cityCode: '341000',
                cityName: '黄山市',
                provinceId: '34',
            },
            {
                cityCode: '341100',
                cityName: '滁州市',
                provinceId: '34',
            },
        ],
    },
    {
        provinceId: '35',
        provinceName: '福建',
        cities: [
            {
                cityCode: '350900',
                cityName: '宁德市',
                provinceId: '35',
            },
            {
                cityCode: '350800',
                cityName: '龙岩市',
                provinceId: '35',
            },
            {
                cityCode: '350700',
                cityName: '南平市',
                provinceId: '35',
            },
            {
                cityCode: '350600',
                cityName: '漳州市',
                provinceId: '35',
            },
            {
                cityCode: '350500',
                cityName: '泉州市',
                provinceId: '35',
            },
            {
                cityCode: '350400',
                cityName: '三明市',
                provinceId: '35',
            },
            {
                cityCode: '350300',
                cityName: '莆田市',
                provinceId: '35',
            },
            {
                cityCode: '350200',
                cityName: '厦门市',
                provinceId: '35',
            },
            {
                cityCode: '350100',
                cityName: '福州市',
                provinceId: '35',
            },
        ],
    },
    {
        provinceId: '36',
        provinceName: '江西',
        cities: [
            {
                cityCode: '360900',
                cityName: '宜春市',
                provinceId: '36',
            },
            {
                cityCode: '360800',
                cityName: '吉安市',
                provinceId: '36',
            },
            {
                cityCode: '360700',
                cityName: '赣州市',
                provinceId: '36',
            },
            {
                cityCode: '360600',
                cityName: '鹰潭市',
                provinceId: '36',
            },
            {
                cityCode: '360500',
                cityName: '新余市',
                provinceId: '36',
            },
            {
                cityCode: '360400',
                cityName: '九江市',
                provinceId: '36',
            },
            {
                cityCode: '360300',
                cityName: '萍乡市',
                provinceId: '36',
            },
            {
                cityCode: '360200',
                cityName: '景德镇市',
                provinceId: '36',
            },
            {
                cityCode: '360100',
                cityName: '南昌市',
                provinceId: '36',
            },
            {
                cityCode: '361100',
                cityName: '上饶市',
                provinceId: '36',
            },
            {
                cityCode: '361000',
                cityName: '抚州市',
                provinceId: '36',
            },
        ],
    },
    {
        provinceId: '37',
        provinceName: '山东',
        cities: [
            {
                cityCode: '370900',
                cityName: '泰安市',
                provinceId: '37',
            },
            {
                cityCode: '370800',
                cityName: '济宁市',
                provinceId: '37',
            },
            {
                cityCode: '370700',
                cityName: '潍坊市',
                provinceId: '37',
            },
            {
                cityCode: '370600',
                cityName: '烟台市',
                provinceId: '37',
            },
            {
                cityCode: '370500',
                cityName: '东营市',
                provinceId: '37',
            },
            {
                cityCode: '371700',
                cityName: '菏泽市',
                provinceId: '37',
            },
            {
                cityCode: '370400',
                cityName: '枣庄市',
                provinceId: '37',
            },
            {
                cityCode: '371600',
                cityName: '滨州市',
                provinceId: '37',
            },
            {
                cityCode: '370300',
                cityName: '淄博市',
                provinceId: '37',
            },
            {
                cityCode: '371500',
                cityName: '聊城市',
                provinceId: '37',
            },
            {
                cityCode: '370200',
                cityName: '青岛市',
                provinceId: '37',
            },
            {
                cityCode: '371400',
                cityName: '德州市',
                provinceId: '37',
            },
            {
                cityCode: '370100',
                cityName: '济南市',
                provinceId: '37',
            },
            {
                cityCode: '371300',
                cityName: '临沂市',
                provinceId: '37',
            },
            {
                cityCode: '371200',
                cityName: '莱芜市',
                provinceId: '37',
            },
            {
                cityCode: '371100',
                cityName: '日照市',
                provinceId: '37',
            },
            {
                cityCode: '371000',
                cityName: '威海市',
                provinceId: '37',
            },
        ],
    },
    {
        provinceId: '41',
        provinceName: '河南',
        cities: [
            {
                cityCode: '411300',
                cityName: '南阳市',
                provinceId: '41',
            },
            {
                cityCode: '410100',
                cityName: '郑州市',
                provinceId: '41',
            },
            {
                cityCode: '411200',
                cityName: '三门峡市',
                provinceId: '41',
            },
            {
                cityCode: '410400',
                cityName: '平顶山市',
                provinceId: '41',
            },
            {
                cityCode: '411500',
                cityName: '信阳市',
                provinceId: '41',
            },
            {
                cityCode: '410300',
                cityName: '洛阳市',
                provinceId: '41',
            },
            {
                cityCode: '419001',
                cityName: '济源市',
                provinceId: '41',
            },
            {
                cityCode: '411400',
                cityName: '商丘市',
                provinceId: '41',
            },
            {
                cityCode: '410200',
                cityName: '开封市',
                provinceId: '41',
            },
            {
                cityCode: '410600',
                cityName: '鹤壁市',
                provinceId: '41',
            },
            {
                cityCode: '411700',
                cityName: '驻马店市',
                provinceId: '41',
            },
            {
                cityCode: '410500',
                cityName: '安阳市',
                provinceId: '41',
            },
            {
                cityCode: '411600',
                cityName: '周口市',
                provinceId: '41',
            },
            {
                cityCode: '410800',
                cityName: '焦作市',
                provinceId: '41',
            },
            {
                cityCode: '410700',
                cityName: '新乡市',
                provinceId: '41',
            },
            {
                cityCode: '410900',
                cityName: '濮阳市',
                provinceId: '41',
            },
            {
                cityCode: '411100',
                cityName: '漯河市',
                provinceId: '41',
            },
            {
                cityCode: '411000',
                cityName: '许昌市',
                provinceId: '41',
            },
        ],
    },
    {
        provinceId: '42',
        provinceName: '湖北',
        cities: [
            {
                cityCode: '421100',
                cityName: '黄冈市',
                provinceId: '42',
            },
            {
                cityCode: '421000',
                cityName: '荆州市',
                provinceId: '42',
            },
            {
                cityCode: '429021',
                cityName: '神农架林区',
                provinceId: '42',
            },
            {
                cityCode: '420200',
                cityName: '黄石市',
                provinceId: '42',
            },
            {
                cityCode: '420100',
                cityName: '武汉市',
                provinceId: '42',
            },
            {
                cityCode: '421300',
                cityName: '随州市',
                provinceId: '42',
            },
            {
                cityCode: '421200',
                cityName: '咸宁市',
                provinceId: '42',
            },
            {
                cityCode: '429006',
                cityName: '天门市',
                provinceId: '42',
            },
            {
                cityCode: '429005',
                cityName: '潜江市',
                provinceId: '42',
            },
            {
                cityCode: '429004',
                cityName: '仙桃市',
                provinceId: '42',
            },
            {
                cityCode: '420300',
                cityName: '十堰市',
                provinceId: '42',
            },
            {
                cityCode: '420600',
                cityName: '襄阳市',
                provinceId: '42',
            },
            {
                cityCode: '420500',
                cityName: '宜昌市',
                provinceId: '42',
            },
            {
                cityCode: '422800',
                cityName: '恩施土家族苗族自治州',
                provinceId: '42',
            },
            {
                cityCode: '420800',
                cityName: '荆门市',
                provinceId: '42',
            },
            {
                cityCode: '420700',
                cityName: '鄂州市',
                provinceId: '42',
            },
            {
                cityCode: '420900',
                cityName: '孝感市',
                provinceId: '42',
            },
        ],
    },
    {
        provinceId: '43',
        provinceName: '湖南',
        cities: [
            {
                cityCode: '433100',
                cityName: '湘西土家族苗族自治州',
                provinceId: '43',
            },
            {
                cityCode: '431100',
                cityName: '永州市',
                provinceId: '43',
            },
            {
                cityCode: '431000',
                cityName: '郴州市',
                provinceId: '43',
            },
            {
                cityCode: '431300',
                cityName: '娄底市',
                provinceId: '43',
            },
            {
                cityCode: '430200',
                cityName: '株洲市',
                provinceId: '43',
            },
            {
                cityCode: '431200',
                cityName: '怀化市',
                provinceId: '43',
            },
            {
                cityCode: '430100',
                cityName: '长沙市',
                provinceId: '43',
            },
            {
                cityCode: '430400',
                cityName: '衡阳市',
                provinceId: '43',
            },
            {
                cityCode: '430300',
                cityName: '湘潭市',
                provinceId: '43',
            },
            {
                cityCode: '430600',
                cityName: '岳阳市',
                provinceId: '43',
            },
            {
                cityCode: '430500',
                cityName: '邵阳市',
                provinceId: '43',
            },
            {
                cityCode: '430800',
                cityName: '张家界市',
                provinceId: '43',
            },
            {
                cityCode: '430700',
                cityName: '常德市',
                provinceId: '43',
            },
            {
                cityCode: '430900',
                cityName: '益阳市',
                provinceId: '43',
            },
        ],
    },
    {
        provinceId: '44',
        provinceName: '广东',
        cities: [
            {
                cityCode: '445300',
                cityName: '云浮市',
                provinceId: '44',
            },
            {
                cityCode: '445200',
                cityName: '揭阳市',
                provinceId: '44',
            },
            {
                cityCode: '442000',
                cityName: '中山市',
                provinceId: '44',
            },
            {
                cityCode: '441300',
                cityName: '惠州市',
                provinceId: '44',
            },
            {
                cityCode: '440200',
                cityName: '韶关市',
                provinceId: '44',
            },
            {
                cityCode: '441200',
                cityName: '肇庆市',
                provinceId: '44',
            },
            {
                cityCode: '440100',
                cityName: '广州市',
                provinceId: '44',
            },
            {
                cityCode: '441500',
                cityName: '汕尾市',
                provinceId: '44',
            },
            {
                cityCode: '440400',
                cityName: '珠海市',
                provinceId: '44',
            },
            {
                cityCode: '441400',
                cityName: '梅州市',
                provinceId: '44',
            },
            {
                cityCode: '440300',
                cityName: '深圳市',
                provinceId: '44',
            },
            {
                cityCode: '441700',
                cityName: '阳江市',
                provinceId: '44',
            },
            {
                cityCode: '440600',
                cityName: '佛山市',
                provinceId: '44',
            },
            {
                cityCode: '441600',
                cityName: '河源市',
                provinceId: '44',
            },
            {
                cityCode: '440500',
                cityName: '汕头市',
                provinceId: '44',
            },
            {
                cityCode: '441900',
                cityName: '东莞市',
                provinceId: '44',
            },
            {
                cityCode: '440800',
                cityName: '湛江市',
                provinceId: '44',
            },
            {
                cityCode: '441800',
                cityName: '清远市',
                provinceId: '44',
            },
            {
                cityCode: '440700',
                cityName: '江门市',
                provinceId: '44',
            },
            {
                cityCode: '445100',
                cityName: '潮州市',
                provinceId: '44',
            },
            {
                cityCode: '440900',
                cityName: '茂名市',
                provinceId: '44',
            },
        ],
    },
    {
        provinceId: '45',
        provinceName: '广西',
        cities: [
            {
                cityCode: '450900',
                cityName: '玉林市',
                provinceId: '45',
            },
            {
                cityCode: '451100',
                cityName: '贺州市',
                provinceId: '45',
            },
            {
                cityCode: '451000',
                cityName: '百色市',
                provinceId: '45',
            },
            {
                cityCode: '451300',
                cityName: '来宾市',
                provinceId: '45',
            },
            {
                cityCode: '450200',
                cityName: '柳州市',
                provinceId: '45',
            },
            {
                cityCode: '451200',
                cityName: '河池市',
                provinceId: '45',
            },
            {
                cityCode: '450100',
                cityName: '南宁市',
                provinceId: '45',
            },
            {
                cityCode: '450400',
                cityName: '梧州市',
                provinceId: '45',
            },
            {
                cityCode: '451400',
                cityName: '崇左市',
                provinceId: '45',
            },
            {
                cityCode: '450300',
                cityName: '桂林市',
                provinceId: '45',
            },
            {
                cityCode: '450600',
                cityName: '防城港市',
                provinceId: '45',
            },
            {
                cityCode: '450500',
                cityName: '北海市',
                provinceId: '45',
            },
            {
                cityCode: '450800',
                cityName: '贵港市',
                provinceId: '45',
            },
            {
                cityCode: '450700',
                cityName: '钦州市',
                provinceId: '45',
            },
        ],
    },
    {
        provinceId: '46',
        provinceName: '海南',
        cities: [
            {
                cityCode: '460100',
                cityName: '海口市',
                provinceId: '46',
            },
            {
                cityCode: '460200',
                cityName: '三亚市',
                provinceId: '46',
            },
            {
                cityCode: '469028',
                cityName: '陵水黎族自治县',
                provinceId: '46',
            },
            {
                cityCode: '469027',
                cityName: '乐东黎族自治县',
                provinceId: '46',
            },
            {
                cityCode: '469026',
                cityName: '昌江黎族自治县',
                provinceId: '46',
            },
            {
                cityCode: '469025',
                cityName: '白沙黎族自治县',
                provinceId: '46',
            },
            {
                cityCode: '469024',
                cityName: '临高县',
                provinceId: '46',
            },
            {
                cityCode: '469023',
                cityName: '澄迈县',
                provinceId: '46',
            },
            {
                cityCode: '469022',
                cityName: '屯昌县',
                provinceId: '46',
            },
            {
                cityCode: '469021',
                cityName: '定安县',
                provinceId: '46',
            },
            {
                cityCode: '469029',
                cityName: '保亭黎族苗族自治县',
                provinceId: '46',
            },
            {
                cityCode: '469030',
                cityName: '琼中黎族苗族自治县',
                provinceId: '46',
            },
            {
                cityCode: '460300',
                cityName: '三沙市',
                provinceId: '46',
            },
            {
                cityCode: '469006',
                cityName: '万宁市',
                provinceId: '46',
            },
            {
                cityCode: '469005',
                cityName: '文昌市',
                provinceId: '46',
            },
            {
                cityCode: '469002',
                cityName: '琼海市',
                provinceId: '46',
            },
            {
                cityCode: '469001',
                cityName: '五指山市',
                provinceId: '46',
            },
            {
                cityCode: '469007',
                cityName: '东方市',
                provinceId: '46',
            },
            {
                cityCode: '460400',
                cityName: '儋州市',
                provinceId: '46',
            },
        ],
    },
    {
        provinceId: '50',
        provinceName: '重庆',
        cities: [
            {
                cityCode: '500118',
                cityName: '永川区',
                provinceId: '50',
            },
            {
                cityCode: '500117',
                cityName: '合川区',
                provinceId: '50',
            },
            {
                cityCode: '500238',
                cityName: '巫溪县',
                provinceId: '50',
            },
            {
                cityCode: '500116',
                cityName: '江津区',
                provinceId: '50',
            },
            {
                cityCode: '500237',
                cityName: '巫山县',
                provinceId: '50',
            },
            {
                cityCode: '500115',
                cityName: '长寿区',
                provinceId: '50',
            },
            {
                cityCode: '500236',
                cityName: '奉节县',
                provinceId: '50',
            },
            {
                cityCode: '500119',
                cityName: '南川区',
                provinceId: '50',
            },
            {
                cityCode: '500242',
                cityName: '酉阳土家族苗族自治县',
                provinceId: '50',
            },
            {
                cityCode: '500120',
                cityName: '璧山区',
                provinceId: '50',
            },
            {
                cityCode: '500241',
                cityName: '秀山土家族苗族自治县',
                provinceId: '50',
            },
            {
                cityCode: '500240',
                cityName: '石柱土家族自治县',
                provinceId: '50',
            },
            {
                cityCode: '500243',
                cityName: '彭水苗族土家族自治县',
                provinceId: '50',
            },
            {
                cityCode: '500154',
                cityName: '开州区',
                provinceId: '50',
            },
            {
                cityCode: '500153',
                cityName: '荣昌区',
                provinceId: '50',
            },
            {
                cityCode: '500152',
                cityName: '潼南区',
                provinceId: '50',
            },
            {
                cityCode: '500151',
                cityName: '铜梁区',
                provinceId: '50',
            },
            {
                cityCode: '500107',
                cityName: '九龙坡区',
                provinceId: '50',
            },
            {
                cityCode: '500228',
                cityName: '梁平县',
                provinceId: '50',
            },
            {
                cityCode: '500106',
                cityName: '沙坪坝区',
                provinceId: '50',
            },
            {
                cityCode: '500105',
                cityName: '江北区',
                provinceId: '50',
            },
            {
                cityCode: '500104',
                cityName: '大渡口区',
                provinceId: '50',
            },
            {
                cityCode: '500109',
                cityName: '北碚区',
                provinceId: '50',
            },
            {
                cityCode: '500108',
                cityName: '南岸区',
                provinceId: '50',
            },
            {
                cityCode: '500229',
                cityName: '城口县',
                provinceId: '50',
            },
            {
                cityCode: '500110',
                cityName: '綦江区',
                provinceId: '50',
            },
            {
                cityCode: '500231',
                cityName: '垫江县',
                provinceId: '50',
            },
            {
                cityCode: '500230',
                cityName: '丰都县',
                provinceId: '50',
            },
            {
                cityCode: '500114',
                cityName: '黔江区',
                provinceId: '50',
            },
            {
                cityCode: '500235',
                cityName: '云阳县',
                provinceId: '50',
            },
            {
                cityCode: '500113',
                cityName: '巴南区',
                provinceId: '50',
            },
            {
                cityCode: '500112',
                cityName: '渝北区',
                provinceId: '50',
            },
            {
                cityCode: '500233',
                cityName: '忠县',
                provinceId: '50',
            },
            {
                cityCode: '500111',
                cityName: '大足区',
                provinceId: '50',
            },
            {
                cityCode: '500232',
                cityName: '武隆县',
                provinceId: '50',
            },
            {
                cityCode: '500103',
                cityName: '渝中区',
                provinceId: '50',
            },
            {
                cityCode: '500102',
                cityName: '涪陵区',
                provinceId: '50',
            },
            {
                cityCode: '500101',
                cityName: '万州区',
                provinceId: '50',
            },
        ],
    },
    {
        provinceId: '51',
        provinceName: '四川',
        cities: [
            {
                cityCode: '513200',
                cityName: '阿坝藏族羌族自治州',
                provinceId: '51',
            },
            {
                cityCode: '512000',
                cityName: '资阳市',
                provinceId: '51',
            },
            {
                cityCode: '511300',
                cityName: '南充市',
                provinceId: '51',
            },
            {
                cityCode: '510100',
                cityName: '成都市',
                provinceId: '51',
            },
            {
                cityCode: '511100',
                cityName: '乐山市',
                provinceId: '51',
            },
            {
                cityCode: '513400',
                cityName: '凉山彝族自治州',
                provinceId: '51',
            },
            {
                cityCode: '511000',
                cityName: '内江市',
                provinceId: '51',
            },
            {
                cityCode: '513300',
                cityName: '甘孜藏族自治州',
                provinceId: '51',
            },
            {
                cityCode: '510600',
                cityName: '德阳市',
                provinceId: '51',
            },
            {
                cityCode: '511800',
                cityName: '雅安市',
                provinceId: '51',
            },
            {
                cityCode: '510500',
                cityName: '泸州市',
                provinceId: '51',
            },
            {
                cityCode: '511700',
                cityName: '达州市',
                provinceId: '51',
            },
            {
                cityCode: '510400',
                cityName: '攀枝花市',
                provinceId: '51',
            },
            {
                cityCode: '511600',
                cityName: '广安市',
                provinceId: '51',
            },
            {
                cityCode: '511400',
                cityName: '眉山市',
                provinceId: '51',
            },
            {
                cityCode: '510300',
                cityName: '自贡市',
                provinceId: '51',
            },
            {
                cityCode: '511500',
                cityName: '宜宾市',
                provinceId: '51',
            },
            {
                cityCode: '510900',
                cityName: '遂宁市',
                provinceId: '51',
            },
            {
                cityCode: '510800',
                cityName: '广元市',
                provinceId: '51',
            },
            {
                cityCode: '510700',
                cityName: '绵阳市',
                provinceId: '51',
            },
            {
                cityCode: '511900',
                cityName: '巴中市',
                provinceId: '51',
            },
        ],
    },
    {
        provinceId: '52',
        provinceName: '贵州',
        cities: [
            {
                cityCode: '522300',
                cityName: '黔西南布依族苗族自治州',
                provinceId: '52',
            },
            {
                cityCode: '520300',
                cityName: '遵义市',
                provinceId: '52',
            },
            {
                cityCode: '522600',
                cityName: '黔东南苗族侗族自治州',
                provinceId: '52',
            },
            {
                cityCode: '520400',
                cityName: '安顺市',
                provinceId: '52',
            },
            {
                cityCode: '522700',
                cityName: '黔南布依族苗族自治州',
                provinceId: '52',
            },
            {
                cityCode: '520100',
                cityName: '贵阳市',
                provinceId: '52',
            },
            {
                cityCode: '520200',
                cityName: '六盘水市',
                provinceId: '52',
            },
            {
                cityCode: '520500',
                cityName: '毕节市',
                provinceId: '52',
            },
            {
                cityCode: '520600',
                cityName: '铜仁市',
                provinceId: '52',
            },
        ],
    },
    {
        provinceId: '53',
        provinceName: '云南',
        cities: [
            {
                cityCode: '530900',
                cityName: '临沧市',
                provinceId: '53',
            },
            {
                cityCode: '530700',
                cityName: '丽江市',
                provinceId: '53',
            },
            {
                cityCode: '530800',
                cityName: '普洱市',
                provinceId: '53',
            },
            {
                cityCode: '533100',
                cityName: '德宏傣族景颇族自治州',
                provinceId: '53',
            },
            {
                cityCode: '530100',
                cityName: '昆明市',
                provinceId: '53',
            },
            {
                cityCode: '532500',
                cityName: '红河哈尼族彝族自治州',
                provinceId: '53',
            },
            {
                cityCode: '533300',
                cityName: '怒江傈僳族自治州',
                provinceId: '53',
            },
            {
                cityCode: '532300',
                cityName: '楚雄彝族自治州',
                provinceId: '53',
            },
            {
                cityCode: '533400',
                cityName: '迪庆藏族自治州',
                provinceId: '53',
            },
            {
                cityCode: '532800',
                cityName: '西双版纳傣族自治州',
                provinceId: '53',
            },
            {
                cityCode: '530500',
                cityName: '保山市',
                provinceId: '53',
            },
            {
                cityCode: '530600',
                cityName: '昭通市',
                provinceId: '53',
            },
            {
                cityCode: '532900',
                cityName: '大理白族自治州',
                provinceId: '53',
            },
            {
                cityCode: '532600',
                cityName: '文山壮族苗族自治州',
                provinceId: '53',
            },
            {
                cityCode: '530300',
                cityName: '曲靖市',
                provinceId: '53',
            },
            {
                cityCode: '530400',
                cityName: '玉溪市',
                provinceId: '53',
            },
        ],
    },
    {
        provinceId: '54',
        provinceName: '西藏',
        cities: [
            {
                cityCode: '540500',
                cityName: '山南市',
                provinceId: '54',
            },
            {
                cityCode: '540300',
                cityName: '昌都市',
                provinceId: '54',
            },
            {
                cityCode: '540400',
                cityName: '林芝市',
                provinceId: '54',
            },
            {
                cityCode: '540100',
                cityName: '拉萨市',
                provinceId: '54',
            },
            {
                cityCode: '542400',
                cityName: '那曲地区',
                provinceId: '54',
            },
            {
                cityCode: '540200',
                cityName: '日喀则市',
                provinceId: '54',
            },
            {
                cityCode: '542500',
                cityName: '阿里地区',
                provinceId: '54',
            },
        ],
    },
    {
        provinceId: '61',
        provinceName: '陕西',
        cities: [
            {
                cityCode: '610600',
                cityName: '延安市',
                provinceId: '61',
            },
            {
                cityCode: '610700',
                cityName: '汉中市',
                provinceId: '61',
            },
            {
                cityCode: '610800',
                cityName: '榆林市',
                provinceId: '61',
            },
            {
                cityCode: '610900',
                cityName: '安康市',
                provinceId: '61',
            },
            {
                cityCode: '610100',
                cityName: '西安市',
                provinceId: '61',
            },
            {
                cityCode: '610200',
                cityName: '铜川市',
                provinceId: '61',
            },
            {
                cityCode: '610300',
                cityName: '宝鸡市',
                provinceId: '61',
            },
            {
                cityCode: '610400',
                cityName: '咸阳市',
                provinceId: '61',
            },
            {
                cityCode: '610500',
                cityName: '渭南市',
                provinceId: '61',
            },
            {
                cityCode: '611000',
                cityName: '商洛市',
                provinceId: '61',
            },
        ],
    },
    {
        provinceId: '62',
        provinceName: '甘肃',
        cities: [
            {
                cityCode: '620800',
                cityName: '平凉市',
                provinceId: '62',
            },
            {
                cityCode: '620900',
                cityName: '酒泉市',
                provinceId: '62',
            },
            {
                cityCode: '620300',
                cityName: '金昌市',
                provinceId: '62',
            },
            {
                cityCode: '620400',
                cityName: '白银市',
                provinceId: '62',
            },
            {
                cityCode: '620500',
                cityName: '天水市',
                provinceId: '62',
            },
            {
                cityCode: '620600',
                cityName: '武威市',
                provinceId: '62',
            },
            {
                cityCode: '622900',
                cityName: '临夏回族自治州',
                provinceId: '62',
            },
            {
                cityCode: '620700',
                cityName: '张掖市',
                provinceId: '62',
            },
            {
                cityCode: '621100',
                cityName: '定西市',
                provinceId: '62',
            },
            {
                cityCode: '621200',
                cityName: '陇南市',
                provinceId: '62',
            },
            {
                cityCode: '620100',
                cityName: '兰州市',
                provinceId: '62',
            },
            {
                cityCode: '620200',
                cityName: '嘉峪关市',
                provinceId: '62',
            },
            {
                cityCode: '623000',
                cityName: '甘南藏族自治州',
                provinceId: '62',
            },
            {
                cityCode: '621000',
                cityName: '庆阳市',
                provinceId: '62',
            },
        ],
    },
    {
        provinceId: '63',
        provinceName: '青海',
        cities: [
            {
                cityCode: '632800',
                cityName: '海西蒙古族藏族自治州',
                provinceId: '63',
            },
            {
                cityCode: '632700',
                cityName: '玉树藏族自治州',
                provinceId: '63',
            },
            {
                cityCode: '632600',
                cityName: '果洛藏族自治州',
                provinceId: '63',
            },
            {
                cityCode: '630200',
                cityName: '海东市',
                provinceId: '63',
            },
            {
                cityCode: '632500',
                cityName: '海南藏族自治州',
                provinceId: '63',
            },
            {
                cityCode: '630100',
                cityName: '西宁市',
                provinceId: '63',
            },
            {
                cityCode: '632300',
                cityName: '黄南藏族自治州',
                provinceId: '63',
            },
            {
                cityCode: '632200',
                cityName: '海北藏族自治州',
                provinceId: '63',
            },
        ],
    },
    {
        provinceId: '64',
        provinceName: '宁夏',
        cities: [
            {
                cityCode: '640300',
                cityName: '吴忠市',
                provinceId: '64',
            },
            {
                cityCode: '640200',
                cityName: '石嘴山市',
                provinceId: '64',
            },
            {
                cityCode: '640100',
                cityName: '银川市',
                provinceId: '64',
            },
            {
                cityCode: '640500',
                cityName: '中卫市',
                provinceId: '64',
            },
            {
                cityCode: '640400',
                cityName: '固原市',
                provinceId: '64',
            },
        ],
    },
    {
        provinceId: '65',
        provinceName: '新疆',
        cities: [
            {
                cityCode: '650100',
                cityName: '乌鲁木齐市',
                provinceId: '65',
            },
            {
                cityCode: '652300',
                cityName: '昌吉回族自治州',
                provinceId: '65',
            },
            {
                cityCode: '654300',
                cityName: '阿勒泰地区',
                provinceId: '65',
            },
            {
                cityCode: '653200',
                cityName: '和田地区',
                provinceId: '65',
            },
            {
                cityCode: '650500',
                cityName: '哈密市',
                provinceId: '65',
            },
            {
                cityCode: '652800',
                cityName: '巴音郭楞蒙古自治州',
                provinceId: '65',
            },
            {
                cityCode: '650400',
                cityName: '吐鲁番市',
                provinceId: '65',
            },
            {
                cityCode: '652700',
                cityName: '博尔塔拉蒙古自治州',
                provinceId: '65',
            },
            {
                cityCode: '659004',
                cityName: '五家渠市',
                provinceId: '65',
            },
            {
                cityCode: '659003',
                cityName: '图木舒克市',
                provinceId: '65',
            },
            {
                cityCode: '659002',
                cityName: '阿拉尔市',
                provinceId: '65',
            },
            {
                cityCode: '659006',
                cityName: '铁门关市',
                provinceId: '65',
            },
            {
                cityCode: '659001',
                cityName: '石河子市',
                provinceId: '65',
            },
            {
                cityCode: '650200',
                cityName: '克拉玛依市',
                provinceId: '65',
            },
            {
                cityCode: '652900',
                cityName: '阿克苏地区',
                provinceId: '65',
            },
            {
                cityCode: '654200',
                cityName: '塔城地区',
                provinceId: '65',
            },
            {
                cityCode: '653100',
                cityName: '喀什地区',
                provinceId: '65',
            },
            {
                cityCode: '653000',
                cityName: '克孜勒苏柯尔克孜自治州',
                provinceId: '65',
            },
            {
                cityCode: '654000',
                cityName: '伊犁哈萨克自治州',
                provinceId: '65',
            },
        ],
    },
    {
        provinceId: '71',
        provinceName: '台湾',
        cities: [
            {
                cityCode: '710630',
                cityName: '云林县',
                provinceId: '71',
            },
            {
                cityCode: '710500',
                cityName: '彰化县',
                provinceId: '71',
            },
            {
                cityCode: '710890',
                cityName: '金门县',
                provinceId: '71',
            },
            {
                cityCode: '710880',
                cityName: '澎湖县',
                provinceId: '71',
            },
            {
                cityCode: '710400',
                cityName: '台中市',
                provinceId: '71',
            },
            {
                cityCode: '710700',
                cityName: '台南市',
                provinceId: '71',
            },
            {
                cityCode: '710950',
                cityName: '台东县',
                provinceId: '71',
            },
            {
                cityCode: '710602',
                cityName: '嘉义县',
                provinceId: '71',
            },
            {
                cityCode: '710600',
                cityName: '嘉义市',
                provinceId: '71',
            },
            {
                cityCode: '710970',
                cityName: '花莲县',
                provinceId: '71',
            },
            {
                cityCode: '710350',
                cityName: '苗栗县',
                provinceId: '71',
            },
            {
                cityCode: '710100',
                cityName: '台北市',
                provinceId: '71',
            },
            {
                cityCode: '710540',
                cityName: '南投县',
                provinceId: '71',
            },
            {
                cityCode: '710302',
                cityName: '新竹县',
                provinceId: '71',
            },
            {
                cityCode: '710300',
                cityName: '新竹市',
                provinceId: '71',
            },
            {
                cityCode: '710207',
                cityName: '新北市',
                provinceId: '71',
            },
            {
                cityCode: '710209',
                cityName: '连江县',
                provinceId: '71',
            },
            {
                cityCode: '710320',
                cityName: '桃园县',
                provinceId: '71',
            },
            {
                cityCode: '710200',
                cityName: '基隆市',
                provinceId: '71',
            },
            {
                cityCode: '710260',
                cityName: '宜兰县',
                provinceId: '71',
            },
            {
                cityCode: '710900',
                cityName: '屏东县',
                provinceId: '71',
            },
            {
                cityCode: '710800',
                cityName: '高雄市',
                provinceId: '71',
            },
        ],
    },
    {
        provinceId: '81',
        provinceName: '香港',
        cities: [
            {
                cityCode: '810110',
                cityName: '荃湾区',
                provinceId: '81',
            },
            {
                cityCode: '810120',
                cityName: '深水涉区',
                provinceId: '81',
            },
            {
                cityCode: '810100',
                cityName: '北区',
                provinceId: '81',
            },
            {
                cityCode: '810150',
                cityName: '湾仔区',
                provinceId: '81',
            },
            {
                cityCode: '810160',
                cityName: '西贡区',
                provinceId: '81',
            },
            {
                cityCode: '810130',
                cityName: '沙田区',
                provinceId: '81',
            },
            {
                cityCode: '810140',
                cityName: '屯门区',
                provinceId: '81',
            },
            {
                cityCode: '810190',
                cityName: '中西区',
                provinceId: '81',
            },
            {
                cityCode: '810170',
                cityName: '油尖旺区',
                provinceId: '81',
            },
            {
                cityCode: '810180',
                cityName: '元朗区',
                provinceId: '81',
            },
            {
                cityCode: '810900',
                cityName: '南区',
                provinceId: '81',
            },
            {
                cityCode: '810700',
                cityName: '葵青区',
                provinceId: '81',
            },
            {
                cityCode: '810600',
                cityName: '九龙城区',
                provinceId: '81',
            },
            {
                cityCode: '810800',
                cityName: '离岛区',
                provinceId: '81',
            },
            {
                cityCode: '810400',
                cityName: '观塘区',
                provinceId: '81',
            },
            {
                cityCode: '810500',
                cityName: '黄大仙区',
                provinceId: '81',
            },
            {
                cityCode: '810200',
                cityName: '大埔区',
                provinceId: '81',
            },
            {
                cityCode: '810300',
                cityName: '东区',
                provinceId: '81',
            },
        ],
    },
    {
        provinceId: '82',
        provinceName: '澳门',
        cities: [
            {
                cityCode: '820700',
                cityName: '望德堂区',
                provinceId: '82',
            },
            {
                cityCode: '820400',
                cityName: '花地玛堂区',
                provinceId: '82',
            },
            {
                cityCode: '820500',
                cityName: '路环岛',
                provinceId: '82',
            },
            {
                cityCode: '820600',
                cityName: '圣安多尼堂区',
                provinceId: '82',
            },
            {
                cityCode: '820200',
                cityName: '氹仔',
                provinceId: '82',
            },
            {
                cityCode: '820300',
                cityName: '风顺堂区',
                provinceId: '82',
            },
            {
                cityCode: '820100',
                cityName: '大堂区',
                provinceId: '82',
            },
        ],
    },
];